module.exports = __webpack_public_path__ + "static/media/oh-no-no.0260b9f7.mp3";